'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _HeaderComponent = require('../../components/common/HeaderComponent');

var _HeaderComponent2 = _interopRequireDefault(_HeaderComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    navigation: state.navigation
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_HeaderComponent2.default);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/common/HeaderContainer.jsx
// module id = 1684
// module chunks = 0